import { getFormattedPrice } from '@/service/utils/getFormattedPrice';
import { TGetCartApiResponse } from '@/domain/Cart.domain';
import { FormDivider } from '@/ui/common/Dividers/FormDivider';
import { Tooltip } from '@/ui/common/Tooltip/Tooltip';
import { TCartState } from '@/service/state/Cart/domain';

type TPriceInfoProps = Partial<TGetCartApiResponse> & {
    tips: TCartState['tips'];
};

export const PriceInfo = ({ subtotal, surcharges, total, tips }: TPriceInfoProps) => (
    <div className="w-full px-5 pt-4 md:px-10 md:pt-6 lg:px-11 lg:pt-0">
        <div className="flex w-full flex-col gap-3">
            <div className="flex w-full items-center justify-between">
                <span className="tx-large-medium text-gray-2 dark:text-white">Subtotal:</span>
                <span
                    className="tx-large-medium text-gray-2 dark:text-white"
                    data-test-id="cart-subtotal"
                >
                    {getFormattedPrice(subtotal!)}
                </span>
            </div>
            <div className="flex w-full items-center justify-between">
                <Tooltip
                    placement="left"
                    text={
                        'If there is more than one Trip you are purchasing, then Tips total is combined here.'
                    }
                >
                    <span className="tx-large-medium text-gray-2 underline decoration-dotted dark:text-white">
                        Tips:
                    </span>
                </Tooltip>
                <span
                    className="tx-large-medium text-gray-2 dark:text-white"
                    data-test-id="cart-tips"
                >
                    {getFormattedPrice(tips!)}
                </span>
            </div>
            <div className="flex w-full items-center justify-between">
                <Tooltip
                    placement="left"
                    text={
                        'Taxes and fees include local and state taxes (when applicable) and a service fee for facilitating your booking. This ensures a high level of traveler services, and secure processing.'
                    }
                >
                    <span className="tx-large-medium text-gray-2 underline decoration-dotted dark:text-white">
                        Taxes & Fees:
                    </span>
                </Tooltip>

                <span
                    className="tx-large-medium text-gray-2 dark:text-white"
                    data-test-id="cart-surcharges"
                >
                    {getFormattedPrice(surcharges!)}
                </span>
            </div>
        </div>
        <FormDivider className="my-[19px] md:mb-[22px] md:mt-[25px] lg:mb-7 lg:mt-8" />
        <div className="flex w-full items-center justify-between">
            <h4 className="tx-heading-4 text-gray-2 dark:text-white">Grand total:</h4>
            <h3
                className="tx-heading-3 text-gray-1 dark:text-white"
                data-test-id="cart-grand-total"
            >
                {getFormattedPrice(total!)}
            </h3>
        </div>
    </div>
);
